module.exports = __webpack_public_path__ + "static/media/faqBalance-es-pt.7e5d17dc.vtt";